<template>
  <div class="page-content">
    <el-row class="common-table-top search-title">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span">编辑广告</span>
      </el-col>
      <el-col :span="20" class="text-align-right">
      </el-col>
    </el-row>
    <el-row class="box-content">
      <div class="box-content-div form-submit-page">
        <el-form :inline="false"  :model="formInline" ref="formInline" :rules="rules" class="box-content-form" label-width="100px">
          <el-form-item label="广告名称:" prop="title">
            <el-input ref="input" v-model="formInline.title" placeholder="请输入广告名" :maxlength=20></el-input>
          </el-form-item>
          <el-form-item label="广告位置:" prop="category_id">
            <el-select v-model="formInline.category_id" placeholder="请选择广告位置">
              <el-option
                v-for="item in categorys"
                :key="item.category_id"
                :label="item.label"
                :value="item.category_id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间:" prop="start">
            <el-date-picker style="width:193px;"
              v-model="formInline.start"
              type="datetime"
              placeholder="开始时间"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间:" prop="end">
            <el-date-picker style="width:193px;"
              v-model="formInline.end"
              type="datetime"
              placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="链接:" prop="url">
             <el-input v-model="formInline.url" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="轮播图:" prop="img">
            <el-upload
              class="acivity-uploader"
              name="file_upload"
              :action="uploadURL"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload">
              <div v-if="formInline.img" class="upload_img">
                <img v-if="formInline.img" :src="formInline.img" class="avatar">
                <div class="modify_img">点击修改</div>
              </div>
              <img v-else src="../../assets/images/Group.png" class="default-acivity">
              <div slot="tip" style="line-height:20px;color:#606266;">只能上传jpg/png文件，尺寸为750X140</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="内容:" class="picture-text-item" prop="content">
            <el-upload class="pic-uploader" action="" :show-file-list="false"></el-upload>
            <!--上面这个el-upload没有作用只是为了撑起form-->
            <editor disabled v-model="formInline.content" class="picture-text-details" :action="uploadURL"></editor>
          </el-form-item>
          <el-form-item label="">
            <el-button class="second-page-btn" style="margin:78px 78px 0 0;float:left" type="primary" @click="saveAdvertiseAction">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-row>
  </div>
</template>
<script>
import { API_HOST } from '@/api/local'
import { getAdvertiseDetails, modifyAdvertise } from '@/api/customer.js'
import editor from '@/components/common/editor'
export default {
  name: 'importData',
  data () {
    return {
      isDisable: true,
      content: '<p></p>',
      formInline: {
        cate: {
          brief: ''
        },
        title: ''
      },
      rules: {
        title: [
          { required: true, message: '请输入广告名', trigger: 'blur' }
        ],
        category_id: [
          { required: true, message: '请选择广告位置', trigger: 'blur' }
        ],
        start: [
          // { type: 'date', required: true, message: '请选择开始时间', trigger: 'blur' }
        ],
        end: [
          // { type: 'date', required: true, message: '请选择结束时间', trigger: 'blur' }
        ],
        img: [
          { required: true, message: '请上传图片', trigger: 'blur' }
        ],
        url: [
          // { required: true, message: '请输入链接', trigger: 'blur' }
        ],
        content: [
          // { required: true, message: '请输入内容', trigger: 'blur' }
        ]
      },
      advertisePosition: '',
      categorys: [
        {
          label: '会员首页',
          category_id: 1
        },
        {
          label: '积分商城',
          category_id: 2
        }
      ]
    }
  },
  methods: {
    saveAdvertiseAction() {
      let id = this.$route.query.id
      this.formInline.description = this.formInline.content
      modifyAdvertise(id, this.formInline).then((res) => {
        if (res.data.code === 0) {
          _g.toastMsg('success', res.data.error)
          router.push('/home/advertise-list')
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    handleAvatarSuccess(res, file) {
      _g.toastMsg('success', '上传成功')
      this.formInline.img = res.data.path
    },
    beforeAvatarUpload(file) {
      _g.toastMsg('success', '正在上传')
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPG && !isPNG) {
        this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return (isJPG && isLt2M) || (isPNG && isLt2M)
    },
    getData() {
      let id = this.$route.query.id
      getAdvertiseDetails(id).then(res => {
        if (res.data.code === 0) {
          this.formInline = res.data.data
          this.$nextTick(() => {
            this.$refs.input.$el.querySelector('input').focus()
          })
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    }
  },
  computed: {
    uploadURL() {
      return API_HOST + 'admin/Upload/upload'
    }
  },
  created() {
    this.getData()
  },
  mounted() {
  },
  components: {
    editor
  }
}
</script>

<style scoped>
.upload_img{
  position: relative;
}
.upload_img:hover .modify_img{
  display: inline-block;
}
.modify_img{
  position: absolute;
  height: 100%;
  width: 100%;
  background: #000;
  opacity: 0.6;
  display: none;
  top: 0;
  left: 0;
  color: #fff;
  font-size: 18px;
  line-height: 78px;
}
.sign-manage-title {
  background: #ecf6ff;
  border: 1px solid #E4e4e4;
  height:60px;
  padding:10px;
  line-height: 40px;
  margin-top: 10px;
}
.box-content-div {
  width: 750px !important;
  padding-left: 20%;
  box-sizing: border-box;
}
.box-content-form {
  margin-top: 30px;
  text-align: center;
}
.box-content-form .el-form-item {
  width: 300px;
}
acivity-uploader .el-upload {
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.acivity-uploader .el-upload:hover {
    border-color: #409EFF;
}
.acivity-uploader-icon {
    border: 1px dashed #d9d9d9;
    font-size: 28px;
    color: #8c939d;
    width: 208px;
    height: 208px;
    line-height: 208px;
    text-align: center;
}
.avatar {
    width: 100%;
    height: 78px !important;
    display: block;
}
.pic-uploader {
    display: none;
}
.only-upload {
    margin: -5px 0 -10px 0;
    text-align: left;
}
</style>
